import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class TicketsService {

  static getAll(options=[], minimal=false) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');      
      axios.get(`${ROOT}tickets${params}&minimal=${minimal}`).then((data) => {
        resolve({ tickets: data.data.content, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static get(ticketId, detail=false) {
    return new Promise((resolve, reject) => {
      let detailParms = detail ? '?projection=detail' : '';
      axios.get(`${ROOT}tickets/${ticketId}${detailParms}`).then((data) => {
        resolve({ ticket: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAllCategories() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}tickets/categories`).then((data) => {
        resolve({ categories: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAllStatuses() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}tickets/statuses`).then((data) => {
        resolve({ statuses: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAllPriorities() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}tickets/priorities`).then((data) => {
        resolve({ priorties: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAllTaskStatuses() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}tickets/task/statuses`).then((data) => {
        resolve({ statuses: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAllTaskTypes() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}tickets/task/types`).then((data) => {
        resolve({ taskTypes: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static save(ticket) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}tickets/${ticket.id}`, ticket).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static addComment(ticketId, comment) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}tickets/${ticketId}/comments`, comment).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static addTask(ticketId, task) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}tickets/${ticketId}/tasks`, task).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static updateTask(ticketId, task) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}tickets/${ticketId}/tasks/${task.id}`, task).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static addTaskComment(ticketId, ticketTaskId, comment) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}tickets/${ticketId}/tasks/${ticketTaskId}/comments`, comment).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      });
    });
  }
}

export default TicketsService;
